import { Dispatch, SetStateAction, useEffect, useState } from 'react';
// import { useParams } from "react-router";
import { useTranslation } from 'react-i18next';

import {
	ModuleNamespaces,
	TranslationNamespaces,
	translationNamespaces,
} from './config';
// import { LanguagesAbbr } from '../types/working-model';

interface UseTranslationModuleProps {
	nameSpace?: TranslationNamespaces[];
	// language?: LanguagesAbbr;
	language?: string;
}

function getLang(lang: string | undefined) {
	if (lang && lang !== 'undefined') {
		return lang;
	}

	return 'en';
}

const useTranslationModules = (
	props: UseTranslationModuleProps
): {
	// selectedLanguage: LanguagesAbbr, setSelectedLanguage: Dispatch<SetStateAction<LanguagesAbbr>>,
	selectedLanguage: string;
	setSelectedLanguage: Dispatch<SetStateAction<string>>;
} => {
	// const [selectedLanguage, setSelectedLanguage] = useState<LanguagesAbbr>(props?.language || 'en');
	const [selectedLanguage, setSelectedLanguage] = useState<string>(getLang(props.language));

	const { i18n } = useTranslation<TranslationNamespaces[]>(
		props?.nameSpace || translationNamespaces
	);

	// dynamically load in the correct i18n json when a user changes their language preference
	useEffect(() => {
		const dynamicallyLoadTranslationModule = async () => {
			const results: ModuleNamespaces[] = await Promise.all(
				translationNamespaces.map((ns: TranslationNamespaces) =>
					import(`./${selectedLanguage}/${ns}.json`)
				)
			);
			translationNamespaces.forEach(
				(ns: TranslationNamespaces, index: number) => {
					i18n.addResourceBundle(
						selectedLanguage,
						ns,
						results[index].default
					);
				}
			);
			i18n.changeLanguage(selectedLanguage);
		};
		dynamicallyLoadTranslationModule();

		//don't reset langauge, this causes some tricky side effects with modals loading and unloading the hook
	}, [selectedLanguage, i18n]);

	useEffect(() => {
		setSelectedLanguage(getLang(props.language));
	}, [props.language]);

	return {
		selectedLanguage,
		setSelectedLanguage,
	};
};

export default useTranslationModules;
